import styled from 'styled-components';

export const Container = styled.div`
  .input-group-text {
    background-color: transparent;
  }
`;
